import { styled } from '@mui/material/styles';

import LB from '@mui/lab/LoadingButton';

const LoadingButton = styled(LB)(({ theme }) => ({
  '&': {
    background: theme.palette.primary.main,
    color: theme.palette.text.secondary,
    borderRadius: '8px',
    height: '60px',
    fontSize: '18px',
    width: '80%',
    textTransform: 'unset !important',
    fontWeight: '500',
    '&.Mui-disabled': {
      color: theme.palette.text.secondary,
      opacity: 0.4,
    },
  },
  '&:hover': {
    background: theme.palette.primary.dark,
  },
}));
export default LoadingButton;
